// Widths from https://github.com/coolblue-development/serverless-image-render-service/blob/master/etc/dimensions.ts
export const supportedWidths = [
    28, // smallProductGalleryImage
    30, // mycoolblue
    35, // extraSmall
    40, // galleryIndexImage
    50, // small
    60, // poosAlternative, checkout
    65, // combinationImage
    70, // checkoutOffer
    75, // Intel processor manufacturer icon image
    78, // return
    80, // promo-box image
    89, // add-to-cart page options row product card (mobile - variant larger)
    94, // add-to-cart page options row product card (desktop - variant larger)
    100, // productPageSquareImage, appPromoIconLarge
    103, // add-to-cart page options row product card (mobile - variant largest)
    108, // shoppingCart, freeWith
    120, // shoppingCartItem
    128, // inruilsite
    134, // add-to-cart page product card (desktop - variant larger)
    138, // Compact card landscape image
    140, // inruilsite
    148, // add-to-cart page product card (desktop - variant largest)
    150, // Coolblue's Keuze - Specialist, appPromoIconExtraLarge
    160, // inruilsite
    170, // responsiveSearchPageImage, combination, VanessaDuPrix
    180, // headerProposition logo, inruilsite
    190, // shoppingCartItem, net-retargeting-feed-service
    192, // Team Email (campaign)
    198, // accessories, facet image navigation, 16:9 image in visual entrances of Hemingway textImageBlock
    200, // cbKeuzeProductView, Product image thank you page, additionalImage, appSearchResults
    210, // inruilsite
    212, // product image catalog pages
    220, // boxedContent
    250, // mainimage, productPageMainImage
    260, // coolblueKeuze
    270, // New Fountain (Leaderboard generator)
    280, // Product bundle image (Mobile)
    300, // Call me back entrance images, energyLabel, appSearchResultsExtraLargeDevice
    310, // Visual entrances
    315, // boxedContent
    320, // Card emphasised small (16:9), Solar & energy small product images, Advies pages, Bundle block main image
    350, // Product bundle image (Desktop), responsiveProductPageMainImage
    368, // mainInformation, poos
    375, // primary leaderboard mobile small
    384, // Team Email (campaign)
    394, // Bannerflow (external party, Leaderboard generator)
    400, // leaderboard, 16:9 entrance card, bannerflow feed, sinterklaas-poem-sharing-bg
    404, // Frontpage, secondary
    422, // secondChance, gallery
    425, // summarisedProduct
    430, // Popover header image
    480, // Advice content, Solar & energy large product images, Newsletter banners
    500, // Frontpage, primary leaderboard mobile, net-retargeting-feed-service, VanessaDuPrix
    512, // Card emphasised medium, Inspirational image mobile (1:1 square)
    560, // Product bundle image (Mobile - Retina)
    580, // Coolblue Energy why Coolblue
    600, // og:image product, appProductPageMediumDevice
    618, // Frontpage, primary leaderboards
    624, // 16:9 image in col--6 in a grid with gap--x-8; e.g. Hemingway textImageBlock,
    668, // Header image small screens
    670, // appProductPageLargeDevice
    700, // Product bundle image (Desktop - Retina)
    800, // FlirtCMS, Google
    825, // Checkout finished page
    828, // appFullscreenImageGallery@2x
    830, // Store awareness product page
    840, // Advice content
    860, // Popover header image x2
    868, // 50% width 21:9 banner Visual pages
    905, // Advice links block
    1024, // Header image medium screens, gallery 1x, appProductPageExtraLargeDevice
    1122, // appProductPageExtraLargePhone
    1236, // Frontpage second primary leaderboard retina
    1242, // appFullscreenImageGallery@3x
    1246, // Advice content, header image
    1248, // Inspirational image desktop (21:9)
    1280, // Header image large screens
    1600, // Mobile Apps Augmented Reality TV textures
    1800, // Header image full width on large screens
    2046, // Header image medium screens 2x (Can be removed after size is fixed on website)
    2048, // gallery zoom 1x, appProductPageExtraLargeDevice 1x,
];
//# sourceMappingURL=supportedWidths.js.map